<template>
  <div id="maverick">
    <template v-if="initState === 1">
      <v-app v-if="$store.state.app.loadTheme">
        <left-menu></left-menu>
        <top></top>
        <!-- <search-bar></search-bar> AR: Commented 1Sep20 N2-65-->
        <back-top></back-top>
        <v-content>
          <v-container fluid fill-height v-scroll="onScroll" id="mavContainer">
            <!-- Transition css from vuetify -->
            <transition name="slide-x-transition" mode="out-in">
              <router-view :key="routeKey"></router-view>
            </transition>
            <search></search>
          </v-container>
        </v-content>
        <div v-if="$store.state.user.rptJob.rptProcess.show" class="processSpacer"></div>
        <rpt-process></rpt-process>
        <bottom></bottom>
      </v-app>
      <v-app v-else>
        <v-content>
          <v-container fluid fill-height v-scroll="onScroll" id="mavContainer" class="emptyContainer">
            <transition name="slide-x-transition" mode="out-in">
              <router-view :key="routeKey"></router-view>
            </transition>
          </v-container>
        </v-content>
      </v-app>
      <v-dialog v-model="$store.state.user.sessionExpired" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Session Expired</v-card-title>
          <v-card-text>Your session has expired. Please login again to renew your session.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="doReload">Reload Application</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template v-else>
      <splash-page></splash-page>
    </template>
    <vue-snotify></vue-snotify>
    <back-top :showButton="showBackTop"></back-top>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import LeftMenu from '@/components/template/LeftMenu'
import Top from '@/components/template/Top'
// import SearchBar from '@/components/template/search/SearchBar'
import Bottom from '@/components/template/Bottom'
import BackTop from '@/components/template/BackTop'
import SplashPage from '@/components/misc/SplashPage'
import Search from '@/components/misc/search/Search'
import RptProcess from '@/components/template/RptProcess'

export default {
  name: 'app',
  data: () => ({
    showBackTop: false
  }),
  computed: {
    initState() {
      return this.$store.state.app.init
    },
    routeKey() {
      if (this.$route.matched && this.$route.matched.length > 0) {
        // This is to solve the route loading fail for pages with same component
        // Eg: SubRoute - Vue JS will reuse same component for same route level, thus not triggering the lifeCycle methods
        // Note: this will only solve the problem for index 0 route
        return this.$route.matched[0].name
      }
      return ''
    }
  },
  methods: {
    ...mapActions([
      'appInit'
    ]),
    onScroll(e) {
      // Scroll listener for back-to-top button
      const offset = window.pageYOffset || document.documentElement.scrollTop
      if (offset && offset > 300) {
        this.showBackTop = true
      } else {
        this.showBackTop = false
      }
    },
    doReload() {
      window.location.reload()
    }
  },
  mounted() {
    this.appInit()

    // Remove Web Notification 1st, IE 11 seems to have some problems
    // Request for permission to send Browser Notification
    // Notification.requestPermission().then(function (result) {
    // })
  },
  components: {
    LeftMenu,
    Top,
    Bottom,
    BackTop,
    // SearchBar,
    SplashPage,
    Search,
    RptProcess
  }
}
</script>

<style lang="scss">
@import '~roboto-fontface/css/roboto/roboto-fontface.css';
@import "~vue-snotify/styles/material";
@import "~mdi/css/materialdesignicons.min.css";
@import "~vuetify/dist/vuetify.min.css";
@import "~hopscotch/dist/css/hopscotch.min.css";
@import "./assets/scss/override.scss";
@import "./assets/scss/index.scss";

#maverick {
  width: 100%;
  height: 100%;
  #mavContainer {
    &.emptyContainer {
      padding: 0px !important;
    }
    align-items: flex-start !important;
  }
  .processSpacer {
    // Spacer to fill up when rptJob Process is shown
    min-height: 30px;
  }

  // Bug in either cssnano or vuetify that v-divider is not showing
  .v-divider {
    border-style: solid !important
  }
}
</style>
